import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

class LayerSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      label: 'name',
      title: 'Camada',
      items: [
        {id: 'FIRST', name: 'Primeira'},
        {id: 'SECOND', name: 'Segunda'}]
    };
  }
}

LayerSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default LayerSelector;



// WEBPACK FOOTER //
// ./src/map/polygon/LayerSelector.js